import React, {useEffect, useRef} from 'react';
import {ISlideStream} from 'shared/collections/SlideStream';
import SlideshowPage from 'client/components/slideshow/SlideshowPage';
import {MeasuredComponentProps} from 'react-measure';
import PasswordForm from './PasswordForm';
import SlideStreamWrapper from 'client/components/slideshow/SlideShowPageWrapper/SlideStreamWrapper';
import isHotkey from 'is-hotkey';
import {methodNames} from 'shared/constants/methodNames';

interface ISlideShowPageWrapperProps {
	isStream: boolean;
	slideshowNumId: string;
	loading: boolean;
	currentStream?: ISlideStream;
}

const SlideshowPageWrapper: React.FC<ISlideShowPageWrapperProps & MeasuredComponentProps> = ({
	currentStream,
	loading,
	contentRect,
	isStream,
	slideshowNumId,
}) => {
	useEffect(() => {
		const hotkeyHandler = (event: KeyboardEvent) => {
			if (!slideshowNumId) return;
			if (isHotkey('mod+shift+e', event)) {
				Meteor.call(
					methodNames.slideshow.getIdByNumber,
					slideshowNumId,
					(err: unknown, res: string) => {
						if (res && typeof res === 'string')
							window.open(`/user/edit/${res}`, '_blank');
					},
				);
			}
		};

		document.addEventListener('keydown', hotkeyHandler);

		return () => document.removeEventListener('keydown', hotkeyHandler);
	});

	if (!isStream) {
		return <SlideshowPage slideNumId={slideshowNumId} />;
	}

	const {current: query} = useRef<URLSearchParams>(new URLSearchParams(location.search));

	if (loading || !contentRect.bounds) {
		return <div>Загрузка...</div>;
	}

	if (!currentStream) {
		return <>Поток не найден</>;
	}

	if (!currentStream.schedules?.length && !currentStream.defaultSlideShowNumId) {
		return <div>В потоке нет слайдов. Добавьте хотя бы 1 слайд в поток.</div>;
	}

	if (currentStream.password && currentStream.password !== query.get('password')) {
		return <PasswordForm />;
	}

	return <SlideStreamWrapper slideStream={currentStream} />;
};

export default SlideshowPageWrapper;
